import React from 'react';
import { LinkIcon } from 'lucide-react';
interface ProvenanceProps {
  source: string;
  label?: string;
  onClick?: () => void;
}
export function Provenance({
  source,
  label = 'View source',
  onClick
}: ProvenanceProps) {
  return <button type="button" onClick={onClick} title={label} className="inline-flex items-center gap-1.5 rounded-md px-2 py-1 text-xs text-blue-600 dark:text-blue-400 hover:bg-blue-50 dark:hover:bg-blue-900/20 transition-colors max-w-full" data-id="element-180">
      <LinkIcon size={12} className="shrink-0" data-id="element-181" />
      <span className="truncate font-medium" data-id="element-182">{source}</span>
    </button>;
}